import { IScorersRankingPlayerPageProps } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const ScorersRankingPlayerPageWrapper = React.lazy(() => import('./scorers-ranking-player-page'));
export interface IDynamicScorersRankingPlayerPage extends IComponentModel<IScorersRankingPlayerPageProps> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicScorersRankingPlayerPage = ({
  /* istanbul ignore next: default value */ model = {} as IScorersRankingPlayerPageProps,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicScorersRankingPlayerPage) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <ScorersRankingPlayerPageWrapper
      live={live}
      initialModel={validateModel(model) as IScorersRankingPlayerPageProps}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicScorersRankingPlayerPage;
